import type { ReactNode } from 'react';
import { cn } from '@/shared/helpers/cn';
import styles from './Fieldset.module.scss';

export interface FieldsetProps {
  legend: string;
  description?: string;
  /** Uma coluna ate `md`, no maximo duas em `lg`. */
  columns?: 1 | 2;
  children: ReactNode;
  className?: string;
}

/**
 * Secao de formulario longo.
 *
 * Formularios como o cadastro de paciente (35 campos) precisam de agrupamento
 * semantico: `fieldset` + `legend` fazem o leitor de tela anunciar a secao ao
 * entrar no primeiro campo dela.
 */
export function Fieldset({ legend, description, columns = 2, children, className }: FieldsetProps) {
  return (
    <fieldset className={cn(styles.fieldset, className)}>
      <legend className={styles.legend}>{legend}</legend>
      {description ? <p className={styles.description}>{description}</p> : null}
      <div className={cn(styles.grid, columns === 2 && styles.twoColumns)}>{children}</div>
    </fieldset>
  );
}
